import React, { Component } from "react";
import user from "../../images/user.png";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { logoutUser,deleteUserAccount } from "../../redux/actions/userActions";
import "./navbar.css";
// import "./navbar.css";
import { NavLink } from "react-router-dom";
import Modal from "../common/modal";

export class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false,

      showEnrollment: false // or true, depending on your default
     };
  }
  moveToLiveSession = e => {
    e.preventDefault();
    this.props.history.push("/live-links");
  };
  moveToLesson = e => {
    e.preventDefault();
    this.props.history.push("/videos");
  };

  _logoutUser = e => {
    e.preventDefault();
    this.props.history.push("/");
    this.props.logoutUser();
  };
  _deleteUserAccount = (e) => {
    e.preventDefault();
    this.setState({ showModal: true });
  };

  handleConfirmDelete = () => {
    const { access_token } = this.props.user;
    this.props.deleteUserAccount(access_token);
    this.setState({ showModal: false });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  componentDidMount() {
    const userLevel = this.props.user && this.props.user.user && this.props.user.user.level;
    if (userLevel === "4" && !this.state.showEnrollment) {
      this.setState({ showEnrollment: true });
    } else if (userLevel !== "4" && this.state.showEnrollment) {
      this.setState({ showEnrollment: false });
    }
  }

  componentDidUpdate(prevProps) {
    const prevLevel = prevProps.user && prevProps.user.user && prevProps.user.user.level;
    const currLevel = this.props.user && this.props.user.user && this.props.user.user.level;
    if (currLevel === "4" && !this.state.showEnrollment) {
      this.setState({ showEnrollment: true });
    } else if (currLevel !== "4" && this.state.showEnrollment) {
      this.setState({ showEnrollment: false });
    }
  }

  render() {
    
    return (
      <React.Fragment>
        <nav className="navbar navbar-light navbar-expand-md bg-faded justify-content-center px-md-5">
          <a
            href="#"
            className="navbar-brand d-flex w-75 mr-auto font-weight-bold"
          >
            Quran Flow
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#collapsingNavbar3"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="navbar-collapse collapse w-100"
            id="collapsingNavbar3"
          >
            <ul className="navbar-nav w-100  justify-content-left">
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  to="/lessons"
                  className="nav-link"
                >
                  LESSONS
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  to="/live-sessions"
                  className="nav-link"
                >
                  Live Sessions
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  to="/recording"
                  className="nav-link"
                >
                  Recording
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  to="/resources"
                  className="nav-link"
                >
                  Resources
                </NavLink>
              </li>
              {/* Enrollment tab disabled for all users per client requirement
              {this.state.showEnrollment && (
               <li className="nav-item">
                <NavLink
                  activeClassName="active"
      to="/enrollment"
      className="nav-link"
    >
      Enrollment
    </NavLink>
  </li>
)}
              */}
            </ul>

            <ul className="navbar-nav justify-content-right ">
              <li className="nav-item dropdown align-profile">
                <a
                  className="dropdown-item mbl-logout-btn"
                  href="#"
                  onClick={this._logoutUser}
                >
                  Logout
                </a>

                <div
                  className="nav-link dropdown-toggle drop-btn"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    src={user}
                    width="40"
                    height="40"
                    className="rounded-circle image"
                  />
                </div>

                <div className="btn-group">
                  <div
                    className="dropdown-menu dropdown-menu-right move-right  "
                    aria-labelledby="navbarDropdownMenuLink"
                  >
                    <a
                      className="dropdown-item logout-btn"
                      href="#"
                      onClick={this._deleteUserAccount}
                    >
                      Delete Account & Cancel Billing
                    </a>
                    <a
                      className="dropdown-item logout-btn"
                      href="#"
                      onClick={this._logoutUser}
                    >
                      Logout
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <Modal
          show={this.state.showModal}
          onClose={this.handleCloseModal}
          onConfirm={this.handleConfirmDelete}
          title="Confirm Account Deletion"
        >
          <p><strong>Are you sure you want to unenroll and delete your account?</strong></p>
          <p>By proceeding with unenrollment and account deletion, your account will be deactivated immediately and your card will no longer be charged.</p>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.myState.user
  };
};
const mapDispatchToProps = {
  logoutUser,
  deleteUserAccount,
};


export default connect(mapStateToProps,mapDispatchToProps)(
  withRouter(Navbar)
);